import zipObject from 'lodash/zipObject';
import { apis } from '@/config';
import { api } from '@/api/api';
class EventLoggerDbImpl {
    constructor() {
        this.dbName = 'loggers';
        this.tableName = 'logger';
        this.highPrioritytableName = 'highLogger';
        this.normalPrioritytableName = 'logger';
        this.lowPrioritytableName = 'lowLogger';
        this.inited = false;
        this.table = { tableName: this.tableName, dbName: this.dbName };
        this.defaultPeriodTime = 24 * 3600 * 1000;
        this.logKeptPeriod = 12 * 3600 * 1000;
        this.clearCheckPeriod = 600 * 1000;
        this.lastPutTimestamp = 0;
        this.db = api.requireLogicalApi(apis.dbInterfaceApiImpl);
    }
    close() {
        this.inited = false;
        try {
            this.db.closeSpecific(this.dbName);
        }
        catch (e) {
            console.warn(e);
        }
    }
    async getByPeriod(period, endTimestamp) {
        const results = await Promise.all(this.buildQuery({ period, endTimestamp }).map(condition => this.db.getByRangeCondition(condition)));
        return zipObject(['high', 'normal', 'low'], results);
    }
    buildQuery(params) {
        const { endTimestamp = Date.now(), period = this.defaultPeriodTime, type = 'between' } = params;
        const start = endTimestamp - period;
        return [this.highPrioritytableName, this.tableName, this.lowPrioritytableName].map(tableName => ({
            adCondition: {
                type,
                args: type === 'between' ? [start, endTimestamp] : [endTimestamp],
                field: 'date',
            },
            count: 1500,
            dbName: this.dbName,
            tableName,
        }));
    }
    init() {
        this.db.initDb(this.dbName);
        this.inited = true;
    }
    async put(data, priority = 'normal') {
        let tableName = this.normalPrioritytableName;
        if (priority === 'high') {
            tableName = this.highPrioritytableName;
        }
        else if (priority === 'low') {
            tableName = this.lowPrioritytableName;
        }
        const random = Math.random() > 0.9;
        if (data && data.length > 0) {
            this.db
                .putAll({
                dbName: this.dbName,
                tableName,
            }, data)
                .then();
        }
        if (random && this.lastPutTimestamp && this.lastPutTimestamp + this.clearCheckPeriod < Date.now()) {
            this.clearByPeriod(this.logKeptPeriod, Date.now() - this.logKeptPeriod).then(() => {
                console.log('[logger-db] clear log from local ');
            });
        }
        return (data === null || data === void 0 ? void 0 : data.length) || 0;
    }
    async clearByPeriod(period, endTimestamp) {
        await Promise.all(this.buildQuery({ period, endTimestamp, type: 'below' }).map(condition => this.db.deleteByByRangeCondition(condition)));
        return 0;
    }
}
export const eventLoggerDbImpl = new EventLoggerDbImpl();
